module.exports = __webpack_public_path__ + "img/no.v4.2.3.1787899191700.png";